
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderShippingItemsReportGrid extends Serenity.EntityGrid<OrderShippingItemsReportRow, any> {
        protected getColumnsKey() { return OrderShippingItemsReportColumns.columnsKey; }
        protected getDialogType() { return OrderShippingItemsReportDialog; }
        protected getIdProperty() { return OrderShippingItemsReportRow.idProperty; }
        protected getInsertPermission() { return OrderShippingItemsReportRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderShippingItemsReportRow.localTextPrefix; }
        protected getService() { return OrderShippingItemsReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}